import { Injectable } from '@angular/core';

import { SiteGroupV2, SiteV2 } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DropdownItemsService {
  constructor() {}

  buildSiteItems(sites: SiteV2[], isColorIcons = false) {
    return sites.map(({ id, site_group_id, name, type, type_name }) => ({
      id,
      site_group_id,
      label: name,
      type,
      typeName: type_name,
      sortKey: `${name.toLowerCase()}${type}`,
      iconClass: isColorIcons ? `alc-site-icon-inline bg-img-${type_name}` : `task-icon task-icon-${type_name}`,
    }));
  }

  buildSiteGroupItems(groups: SiteGroupV2[]) {
    return groups.map(group => ({
      isGroup: true,
      id: group.id,
      label: `[Group] ${group.name}`,
      type: group.type,
      typeName: group.type_name,
      sortKey: `${group.name.toLowerCase()}${group.type}`,
    }));
  }
}
